import { render, staticRenderFns } from "./takingsOverviewTable.vue?vue&type=template&id=297cea98&"
import script from "./takingsOverviewTable.vue?vue&type=script&lang=ts&"
export * from "./takingsOverviewTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports